module.exports = __webpack_public_path__ + "static/media/logo-uerre-negro.46afa474.png";